import { HIDE_SERVICE } from './utils/config'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import Header from './components/header/header.component'
import Nav from './components/nav/nav.component'
import About from './components/about/about.component'
import Expereince from './components/expereince/experience.component'
import Services from './components/services/services.component'
import Portfolio from './components/portfolio/portfolio.component'
import Testimonial from './components/testimonial/testimonial.component'
import Contact from './components/contact/contact.component'
import Footer from './components/footer/footer.component'
import Achivement from './components/achivements/achivement.component'
const App = () => {
  toast.configure({
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
  })

  return (
    <>
      <Header />
      <Nav />
      <About />
      <Expereince />
      {HIDE_SERVICE && <Services />}
      <Portfolio />
      <Achivement />
      {HIDE_SERVICE && <Testimonial />}
      <Contact />
      <Footer />
    </>
  )
}

export default App
